import { render, staticRenderFns } from "./MyPageDisbursements.vue?vue&type=template&id=cc4858a0&scoped=true&"
import script from "./MyPageDisbursements.vue?vue&type=script&lang=js&"
export * from "./MyPageDisbursements.vue?vue&type=script&lang=js&"
import style0 from "./MyPageDisbursements.vue?vue&type=style&index=0&id=cc4858a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4858a0",
  null
  
)

export default component.exports